import styles from "./index.module.scss";
import cn from "classnames";
import { useEffect, useState } from "react";
import IconFont from "@/components/IconFont";

type ButtonTypes = "default" | "primary";
enum ButtonTypesMapping {
  DEFAULT = "default",
  PRIMARY = "primary",
  // other ...
}

interface ButtonProps {
  type?: ButtonTypes;
  disabled?: boolean;
  icon?: React.ReactNode;
  wrapperClass?: string;
  loading?: boolean;
  block?: boolean;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  id?: string;
}

const RFButton = (props: ButtonProps) => {
  const {
    children,
    disabled,
    type,
    icon,
    wrapperClass,
    loading,
    block,
    style,
    onClick,
  } = props;

  const [btnClassName, setBtnClassName] = useState("");
  useEffect(() => {
    let typeMapClassName;
    switch (type) {
      case ButtonTypesMapping.PRIMARY:
        typeMapClassName = styles.primary;
        break;
      // other ..
      default:
        typeMapClassName = styles.default;
        break;
    }
    setBtnClassName(
      cn(
        styles.rfBtn,
        typeMapClassName,
        disabled && styles.disabled,
        loading && styles.loading,
        block && styles.block,
        wrapperClass
      )
    );
  }, [type, disabled, loading, block, wrapperClass]);

  const handleClick = (
    e: React.MouseEvent<HTMLDivElement | HTMLAnchorElement, MouseEvent>
  ) => {
    e.stopPropagation();
    if (disabled || loading) {
      return;
    }
    (onClick as React.MouseEventHandler<HTMLDivElement | HTMLAnchorElement>)?.(
      e
    );
  };

  return (
    <div style={style} className={btnClassName} onClick={handleClick}>
      <a className={styles.content} id={props.id}>
        {loading && <IconFont type="loading" className={styles.loadingIcon} />}
        {icon}
        <span>{children}</span>
      </a>
    </div>
  );
};

export default RFButton;
